export default "__VITE_ASSET__sX9pCmzM__"